import React from "react";

const Welcome = () => (
  <div className="jumbotron">
    <h1>Fire Emblem Fated Memories</h1>
    <p>
      How good are you at remembering the heroes? Your goal is to click
      the picture of every hero exactly once. The images will shuffle after
      every click. You get points for clicking another, different hero, but if you click the 
      same hero twice your counter will reset. Good Luck!
    </p>
  </div>
);

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/Welcome.js